function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 8 */
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n";
import { OpportunitiesApiService } from "./Services/OpportunitiesApiService";
import { DropdownBuilder } from "./Helpers/DropdownBuilder";
import { CardBuilder } from "./Helpers/CardBuilder";
import { QueryStringFilter } from "./Shared/QueryStringFilter";
import { AttributeFilter } from "./Shared/AttributeFilter";
import { ReturnContext } from "./Shared/ReturnContextProvider";
import { ErrorBuilder } from "./Helpers/ErrorBuilder";
import { PillDropDownBuilder } from "./Helpers/PillDropDownBuilder";
import { Configuration } from "./Shared/Configuration";
export var MppOpportunityFinder = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppOpportunityFinder, _ComponentBase);

  var _super = _createSuper(MppOpportunityFinder);

  function MppOpportunityFinder() {
    _classCallCheck(this, MppOpportunityFinder);

    return _super.call(this);
  }

  _createClass(MppOpportunityFinder, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if (!!this._$searchButton) {
        if (this.loadAttributes()) {
          this._$searchButton.click();
        }
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.targetUrl = this.getAttribute("targeturl") || this.getAttribute("target");
      this.showAttributeFilter = this.getAttribute("showattributefilter") || true;
      this.chosenAttributes = this.getAttribute("attributeids") || "";

      if (!this.showAttributeFilter) {
        this.chosenAttributes = "";
      }

      var attributesChanged = false;

      if (!!this._$searchForm) {
        attributesChanged = AttributeFilter.ApplyFilter(this, this._$searchForm);
      }

      return attributesChanged;
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this,
            _mppWidgetsConfigValu;

        var i18n, mppWidgetsConfigValues, opportunitiesService;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new I18N(MppOpportunityFinder.WidgetDetails.tag)["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  } else {
                    _this._root.innerHTML = "".concat(error);
                  }
                });

              case 2:
                i18n = _context.sent;
                this._i18n = i18n; //Load initial values of tag attributes:

                this.loadAttributes();
                _context.next = 7;
                return new Configuration().GetGlobalConfigurationSettingValues();

              case 7:
                mppWidgetsConfigValues = _context.sent;
                this._opportunityDetailWidgetIdParameterName = (_mppWidgetsConfigValu = mppWidgetsConfigValues.opportunityDetailWidgetIdParameterName) !== null && _mppWidgetsConfigValu !== void 0 ? _mppWidgetsConfigValu : "id"; // HTML Template:

                this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container"><div class="mppw-form-wrapper"><h1>${ i18n.pageTitle }</h1><form class="mppw-form mppw-form-validate" id="searchForm"><input type="hidden" id="event" name="eventId" class="search-option"/> <input type="hidden" id="program" name="programId" class="search-option"/><div class="mppw-form-field mppw-form-field__static-container"><select name="congregationId" class="mppw-form-field__control search-option" id="congregationId" value=""></select> <label class="mppw-form-field__label" for="congregationId">${ i18n.congregationLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><input name="keyword" class="mppw-form-field__control search-option" type="text" id="searchText"/> <label class="mppw-form-field__label" for="searchText">${ i18n.keyWordLabel }</label></div><div class="mppw-right"><a class="mppw-btn secondary mppw-btn--small" href="#" id="advancedSearchLink" data-searchmode="0">${i18n.showAdvancedSearchLabel }</a></div><div id="advancedSearchSection" style="display: none"><div class="mppw-form-field mppw-form-field__static-container"><select name="ministryId" class="mppw-form-field__control search-option advanced-option" id="ministryId" value=""></select> <label class="mppw-form-field__label" for="ministryId">${ i18n.ministryLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><select name="genderId" class="mppw-form-field__control search-option advanced-option" id="genderId" value=""></select> <label class="mppw-form-field__label" for="genderId">${ i18n.genderRequiredLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><input name="minimumAge" class="mppw-form-field__control search-option advanced-option" type="number" id="ageText" step="1"/> <label class="mppw-form-field__label" for="ageText">${ i18n.ageRequiredLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><select name="frequency" class="mppw-form-field__control" value=""><option value="">All Opportunities</option><option value="1">${ i18n.ongoingLabel }</option><option value="2">${ i18n.oneTimeLabel }</option></select> <label class="mppw-form-field__label" for="frequency">${ i18n.frequencyLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container" id="attributeTypeSection" style="display: none"><select name="attributeType" class="mppw-form-field__control search-option advanced-option" id="attributeType" value=""></select> <label class="mppw-form-field__label" for="attributetype">${ i18n.attributeTypeLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container" id="attributesSelectedSection" style="display: none"><input type="hidden" id="attributeIDs" name="attributeIDs"/><div id="attributesSelected"></div></div></div><div class="mppw-centered"><input type="submit" class="mppw-btn primary" id="searchButton" value="${ i18n.searchButtonText }"/></div></form></div><div id="emptyContainer"><i class="mppw-spinner"></i></div><div class="resultsContainer mppw-card--grid" id="resultsContainer"></div><div id="viewMoreContainer"></div></div>` ; // Select items from template.  Use $ as convention indicating a DOM element:

                this._$searchForm = this._root.querySelector("#searchForm");
                this._$congregationId = this._root.querySelector("#congregationId");
                this._$ministryId = this._root.querySelector("#ministryId");
                this._$searchButton = this._root.querySelector("#searchButton");
                this._$resultsContainer = this._root.querySelector("#resultsContainer");
                this._$emptyContainer = this._root.querySelector("#emptyContainer");
                this._$advancedSearchLink = this._root.querySelector("#advancedSearchLink");
                this._$advancedSearchSection = this._root.querySelector("#advancedSearchSection");
                this._$attributeTypeSection = this._root.querySelector("#attributeTypeSection");
                this._$attributesSelectedSection = this._root.querySelector("#attributesSelectedSection");
                this._$attributesSelected = this._root.querySelector("#attributesSelected");
                this._$attributeType = this._root.querySelector("#attributeType");
                this._$attributeIDs = this._root.querySelector("#attributeIDs");
                this._$viewMoreContainer = this._root.querySelector("#viewMoreContainer");
                this._$keywordSearchText = this._root.querySelector("#searchText");
                this._$ageText = this._root.querySelector("#ageText");
                this._$event = this._root.querySelector("#event");
                this._$program = this._root.querySelector("#program");
                this._$genderId = this._root.querySelector("#genderId");
                this._hasAttributeTypes = false;
                this._dataAttributeTypes = [];

                if (!this.showAttributeFilter) {
                  this.chosenAttributes = "";
                  this._$attributeTypeSection.style.display = "none";
                  this._$attributesSelectedSection.style.display = this._$attributeTypeSection.style.display;
                }

                opportunitiesService = new OpportunitiesApiService();
                opportunitiesService.GetConfigurations().then(function (data) {
                  DropdownBuilder.LoadDropdown(_this._$congregationId, data.congregations, i18n.congregationPlaceHolderText);
                  DropdownBuilder.LoadDropdown(_this._$ministryId, data.ministries, i18n.ministryPlaceHolderText);
                  DropdownBuilder.LoadDropdown(_this._$genderId, data.genders, i18n.genderPlaceHolderText);

                  if (_this.showAttributeFilter) {
                    _this._hasAttributeTypes = data.attributeTypes.length > 0;

                    if (_this._hasAttributeTypes) {
                      _this._dataAttributeTypes = data.attributeTypes;

                      if (_this.chosenAttributes === "") {
                        DropdownBuilder.BuildDropdownWithOptGroup(_this._$attributeType, _this._dataAttributeTypes, i18n.attributeTypePlaceHolderText);
                      }
                    }
                  }

                  var advancedSearchOpened = false;
                  var returnContext = ReturnContext.Get(ReturnContext.Categories.Opportunities);

                  if (!!returnContext && returnContext.Url == window.location.href) {
                    advancedSearchOpened = ReturnContext.ApplyFilter(returnContext.FormData, _this._$searchForm, _this._$advancedSearchSection);
                  } else {
                    advancedSearchOpened = QueryStringFilter.ApplyFilter(_this._$searchForm, _this._$advancedSearchSection);
                  }

                  AttributeFilter.ApplyFilter(_this, _this._$searchForm, true); //This could be improved since it duplicates code from below:

                  if (!!advancedSearchOpened) {
                    _this._$advancedSearchLink.innerHTML = i18n.hideAdvancedSearchLabel;
                    _this._$advancedSearchSection.style.display = "block";

                    if (_this.showAttributeFilter && _this._hasAttributeTypes && _this.chosenAttributes === "") {
                      _this._$attributeTypeSection.style.display = "block";
                    } else {
                      _this._$attributeTypeSection.style.display = "none";
                    }

                    _this._$attributesSelectedSection.style.display = _this._$attributeTypeSection.style.display;

                    _this._$advancedSearchLink.setAttribute("data-searchmode", "1");
                  }

                  _this._$searchButton.click();
                })["catch"](function (error) {
                  console.error(error);
                }); // Wire-up search button:

                this._$searchForm.addEventListener("submit", function (event) {
                  event.preventDefault();
                  var formData = new FormData(_this._$searchForm);
                  _this._$emptyContainer.innerHTML = "<i class=\"mppw-spinner\"></i>";
                  var resultsContainerHTML = "";
                  _this._$resultsContainer.innerHTML = resultsContainerHTML;
                  ReturnContext.Set(ReturnContext.Categories.Opportunities, formData);
                  opportunitiesService.GetOpportunities(formData).then(function (data) {
                    _this._$emptyContainer.innerHTML = "";

                    if (data.length === 0) {
                      _this._$emptyContainer.innerHTML += "<div id=\"opportunitiesEmpty\" class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(i18n.noOpportunitiesFoundMessage, "</span>\n\t\t\t\t\t\t</div>");
                    } else {
                      for (var i = 0; i < data.length; i++) {
                        var _meetingDayText;

                        var _data$i = _objectSpread({}, data[i]),
                            featured = _data$i.featured,
                            imageUrl = _data$i.imageUrl,
                            title = _data$i.title,
                            description = _data$i.description,
                            id = _data$i.id,
                            location = _data$i.location,
                            meetingDay = _data$i.meetingDay,
                            meetingTime = _data$i.meetingTime;

                        var meetingDayText = meetingDay;

                        if (((_meetingDayText = meetingDayText) === null || _meetingDayText === void 0 ? void 0 : _meetingDayText.toLowerCase()) === "ongoing" && _this._i18n.ongoingLabel) {
                          meetingDayText = _this._i18n.ongoingLabel;
                        }

                        var subtitlesArr = CardBuilder.BuildOpportunitySubtitlesArr(location, meetingDayText, meetingTime);
                        var targetUrl = CardBuilder.BuildUrl(_this.targetUrl, id, _this._opportunityDetailWidgetIdParameterName);
                        resultsContainerHTML += CardBuilder.BuildCard(CardBuilder.BuildBadge(featured) + CardBuilder.BuildImage(imageUrl, 'opportunity'), CardBuilder.BuildText(title, subtitlesArr, description), CardBuilder.BuildDetailsButton(id, targetUrl, i18n.seeDetailsButtonText, _this._opportunityDetailWidgetIdParameterName), targetUrl);
                      }

                      _this._$resultsContainer.innerHTML += resultsContainerHTML;

                      if (data.length > 20) {
                        _this._$viewMoreContainer.innerHTML = "<div class=\"mppw-alert mppw-alert__info\">\n\t\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(i18n.viewMoreLabel, "</span>\n\t\t\t\t\t\t\t</div>");
                      } else {
                        _this._$viewMoreContainer.innerHTML = "";
                      }
                    }
                  })["catch"](ErrorBuilder.RenderHandler(_this._$emptyContainer));
                });

                this._$advancedSearchLink.addEventListener("click", function (event) {
                  var searchMode = _this._$advancedSearchLink.getAttribute("data-searchmode");

                  if (searchMode === "0") {
                    _this._$advancedSearchLink.innerHTML = _this._i18n.hideAdvancedSearchLabel;
                    _this._$advancedSearchSection.style.display = "block";

                    _this._$advancedSearchLink.setAttribute("data-searchmode", "1");
                  } else {
                    _this._$advancedSearchLink.innerHTML = _this._i18n.showAdvancedSearchLabel;
                    _this._$advancedSearchSection.style.display = "none";

                    _this._$advancedSearchLink.setAttribute("data-searchmode", "0");
                  }

                  if (_this._$ministryId.value === "") {
                    _this._$ministryId.selectedIndex = "0";
                  }

                  _this._$genderId.selectedIndex = "0";
                  _this._$ageText.value = "";

                  if (_this.showAttributeFilter && _this._hasAttributeTypes && _this.chosenAttributes === "") {
                    _this._$attributeTypeSection.style.display = "block";
                    _this._$attributeType.selectedIndex = "0";
                  } else {
                    _this._$attributeTypeSection.style.display = "none";
                  }

                  _this._$attributesSelectedSection.style.display = _this._$attributeTypeSection.style.display;
                  event.preventDefault();
                });

                this._$attributeTypeSection.addEventListener("change", function () {
                  PillDropDownBuilder.AddPill(_this._$attributeType, _this._$attributeType.selectedIndex, _this._$attributesSelected, _this._$attributeIDs);
                });

              case 37:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "Opportunity Finder",
        tag: "mpp-opportunity-finder",
        configurationItems: [{
          name: "Target URL",
          attribute: "targeturl",
          description: "Determines the navigation path to Opportunity Details. When a specific Opportunity is selected, the ID is appended to this path.",
          required: true,
          type: "url"
        }, {
          name: "Congregation",
          attribute: "congregationid",
          description: "Filters the results by a single Congregation ID.",
          required: false,
          type: "foreignkey",
          fkTable: "Congregations",
          fkFilter: "",
          fkSingleName: "Congregation"
        }, {
          name: "Key Word",
          attribute: "keyword",
          description: "Filters results using key words. A Key Word search looks fora match in the Title, Description, Program Name, and/or Ministry Name, so choose key word attributes strategically.",
          required: false,
          type: "text"
        }, {
          name: "Ministry",
          attribute: "ministryid",
          description: "Filters by a Ministry ID (Default: Empty or NULL).",
          required: false,
          type: "foreignkey",
          fkTable: "Ministries",
          fkFilter: "",
          fkSingleName: "Ministry"
        }, {
          name: "Gender",
          attribute: "genderid",
          description: "Filters by Gender. (Default: Empty or NULL).",
          required: false,
          type: "foreignkey",
          fkTable: "Genders",
          fkFilter: "",
          fkSingleName: "Gender"
        }, {
          name: "Minimum Age",
          attribute: "minimumage",
          description: "Filters by a minimum age requirement (Default: Empty or NULL).",
          required: false,
          type: "number"
        }, {
          name: "Frequency",
          attribute: "frequency",
          description: "Filters by the frequency of the opportunity.",
          required: false,
          type: "list",
          listValues: [{
            label: "Both",
            value: ""
          }, {
            label: "Ongoing",
            value: 1
          }, {
            label: "One Time",
            value: 2
          }]
        }, {
          name: "Event",
          attribute: "eventid",
          description: "Filters for Opportunities associated with an Event ID (Default: Empty or NULL).",
          required: false,
          type: "number"
        }, {
          name: "Program",
          attribute: "programid",
          description: "Filters Opportunities based on Program ID (Default: Empty or NULL).",
          required: false,
          type: "foreignkey",
          fkTable: "Programs",
          fkFilter: "",
          fkSingleName: "Program"
        }, {
          name: "Show Attribute Filter",
          attribute: "showattributefilter",
          description: "When True (or NULL), the attribute filter will be visible in the finder. Default is NULL or True.",
          required: false,
          type: "bool"
        }, {
          name: "Attribute IDs",
          attribute: "attributeids",
          description: "Filters by selected attribute type(s). Example values: 11 or 9,2,28. Default is Empty or NULL.",
          required: false,
          type: "text"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["target", "targeturl", "programid", "congregationid", "keyword", "ministryid", "genderid", "minimumage", "frequency", "showattributefilter", "attributeids"];
    }
  }]);

  return MppOpportunityFinder;
}(ComponentBase);
MppOpportunityFinder.registerComponent(MppOpportunityFinder.WidgetDetails.tag, MppOpportunityFinder);